import { EventEntity } from '@/entities/interfaces/events';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export const useEventStore = defineStore('events', () => {
  const event = ref<EventEntity>();
  const events = ref<EventEntity[]>();
  const eventsTimeline = ref<{
    nextEvents: EventEntity[];
    prevEvents: EventEntity[];
  }>();

  const getEvent = computed(() => event);
  const getEvents = computed(() => events);
  const getEventsTimeline = computed(() => eventsTimeline);

  const setEvents = (action: EventEntity[]) => {
    events.value = action;
  };

  const setEventsTimeline = (action: {
    nextEvents: EventEntity[];
    prevEvents: EventEntity[];
  }) => {
    eventsTimeline.value = action;
  };

  const setEvent = (action: EventEntity) => {
    event.value = action;
  };

  const getEventById = (action: string) => {
    const filtered = events.value?.filter((event) => event.id == action);
    return filtered ? filtered[0] : undefined;
  };

  return {
    setEvent,
    setEvents,
    setEventsTimeline,
    getEvent,
    getEvents,
    getEventsTimeline,
    getEventById
  };
});
